import ChangeList from './ChangeList';

export default {
  list: ChangeList,
}
